import { brandApi } from "../lib/axios";

export interface TestAffiliateAccount {
  affiliateId: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  accountType: string;
  accountNumber: number;
}

/**
 * Get test affiliate accounts for the current brand
 * Only available for dev store brands
 */
export const getTestAccounts = async (): Promise<TestAffiliateAccount[]> => {
  const response = await brandApi.get<TestAffiliateAccount[]>("/test-affiliates/brand");
  return response.data;
};

/**
 * Manually create test accounts (optional endpoint)
 */
export const createTestAccounts = async (): Promise<{ message: string }> => {
  const response = await brandApi.post<{ message: string }>("/test-affiliates/create");
  return response.data;
};

const testAffiliatesService = {
  getTestAccounts,
  createTestAccounts,
};

export default testAffiliatesService;
